module.exports = __webpack_public_path__ + "img/basket-outline.a13cec41.svg";